export default async function useDoWhileWithDelay(func: () => unknown, conditionFunc: () => boolean, delay: number, repeats?: number) {
    let count = 0;
    const timer = (ms: number) => new Promise(res => setTimeout(res, ms));
    do {
        func();
        count++;
        await timer(delay);
    } while (conditionFunc() && (!repeats || count < repeats));
}
